import { useEffect, useState } from "react";
import { Sparkle } from "lucide-react";
import { api } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import ProductCard from "@/components/ProductCard";

export default function NewArrivals() {
  const { profile, addToWishlist, inWishlist } = useProfile();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!profile) return;
    api.get("/catalog/new-arrivals", { params: { profile_id: profile.id } })
      .then(({ data }) => setItems(data.products)).catch(() => setItems([]));
  }, [profile?.id, profile?.sex, profile?.due_date]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!profile || !items.length) return null;
  return (
    <section id="nuovi-arrivi" data-testid="new-arrivals" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-8 sm:py-12 scroll-mt-16">
      <div className="flex items-center gap-2 text-[#4E7363] mb-2">
        <Sparkle size={15} />
        <span className="text-xs uppercase tracking-[0.2em] font-semibold">Ultimi 30 giorni</span>
      </div>
      <h2 className="font-serif text-2xl sm:text-3xl text-[#2D2825]" data-testid="new-arrivals-title">Nuovi arrivi</h2>
      <p className="text-sm text-[#5C534E] mt-1 mb-6 max-w-xl">Le novità appena arrivate in negozio, già nella taglia giusta per il tuo bimbo.</p>
      <div className="loved-rail" data-testid="new-arrivals-rail">
        {items.map((p, i) => (
          <div key={p.id} className="relative">
            <span className="absolute top-2 right-2 z-10 rounded-full bg-[#4E7363] text-white text-[10px] px-2 py-0.5" data-testid={`new-badge-${p.id}`}>Novità</span>
            <ProductCard product={p} onAdd={addToWishlist} inList={inWishlist(p.id)} delay={Math.min(i, 5) * 0.04} testid={`new-arrival-card-${p.id}`} />
          </div>
        ))}
      </div>
    </section>
  );
}
